module.exports = __webpack_public_path__ + "3b240ce2f2f38afeb372f8415ac69af0.svg";